// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader-module__root___1fJwF","text":"Loader-module__text___g00k- Fonts-module__at___1f_7n"};